<version-reload></version-reload>
<ngx-loading-bar></ngx-loading-bar>
<main-nav></main-nav>
<mat-card class="main">
  <mat-card-content>
    <router-outlet></router-outlet>
  </mat-card-content>
</mat-card>
